import Collection from '../collection';

import { hashify, } from './arrays';

export { contains, subtract };



function contains(collection) {
    const hash = collection instanceof Collection
        ? hashify( collection.toJSON(), model => [model.id, true] )
        : hashify( collection, model => [model.id, true] );

    return model => hash[model.id];
}

function subtract(from, what) {
    const hash = hashify( what, item => [item.id, true] );

    const models = from instanceof Collection ? from.models : from;
    const filtered = models
        .filter( model => !hash[model.id] );

    return from instanceof Collection ? new Collection( filtered ) : filtered;
}


// WEBPACK FOOTER //
// ./src/js/utils/collections.js